function initExpertSection(section) {
  // Initialize each expert section individually
  const expertSections = document.querySelectorAll("[data-expert-section]");

  expertSections.forEach((expertContainer) => {
    const nextBtn = expertContainer.querySelector(".swiper-expert-button-next");
    const prevBtn = expertContainer.querySelector(".swiper-expert-button-prev");

    // --- Video Play Buttons ---
    const playButtons = expertContainer.querySelectorAll("[data-play-button]");

    playButtons.forEach((button) => {
      // Avoid attaching listener multiple times
      if (button.dataset.listenerAttached) return;
      button.dataset.listenerAttached = "true";

      button.addEventListener("click", () => {
        const parent = button.parentElement;
        const video = parent.querySelector("video");
        if (!video) return;

        if (video.paused) {
          // Pause all other videos in this expert section
          expertContainer
            .querySelectorAll(".c-expert-recommended__content-video.is-playing")
            .forEach((v) => {
              const vid = v.querySelector("video");
              if (vid) vid.pause();
              v.classList.remove("is-playing");
              const btn = v.querySelector("[data-play-button]");
              if (btn) btn.classList.remove("is-playing");
            });

          // Play this video
          video.play();
          parent.classList.add("is-playing");
          button.classList.add("is-playing");
        } else {
          // Pause this video
          video.pause();
          parent.classList.remove("is-playing");
          button.classList.remove("is-playing");
        }
      });
    });

    // --- Swiper ---
    const expertSwiperEl = expertContainer.querySelector(
      "[data-swiper-expert]"
    );
    if (!expertSwiperEl) return;

    const expertSwiper = new Swiper(expertSwiperEl, {
      slidesPerView: 1.25,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: expertContainer.querySelector(".swiper-expert-pagination"),
        type: "progressbar",
      },
      breakpoints: {
        768: { slidesPerView: 2.25 },
        1024: { slidesPerView: 3, spaceBetween: 32 },
      },
    });

    nextBtn.addEventListener("click", (e) => {
      expertSwiper.slideNext();
    });

    prevBtn.addEventListener("click", (e) => {
      expertSwiper.slidePrev();
    });
  }); // end forEach
}
// Run on page load
document.addEventListener('DOMContentLoaded', () => initExpertSection());

// Run whenever Shopify editor loads or adds a section
document.addEventListener('shopify:section:load', (event) => initExpertSection(event.target));



